import { useReactiveVar } from '@apollo/client';
import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext.tsx';
import type { DealFormState, DealState } from '@openx/types/deal.ts';
import type { PackageFormState } from '@openx/types/package.ts';
import { useAuth } from '../../../components/AuthContext/context.ts';
import { dealFormState } from '../../../modules/graphql/cache.ts';

type DealNTargeting = DealState & Pick<PackageFormState, 'targeting'>;
export const useDealFormSelector: DealProviderConfig['useDealFormSelector'] = <
  T extends DealState = DealNTargeting,
>() => {
  const { session } = useAuth();
  const defaultAccountUid = session?.exchange_session?.account?.uid ?? null;

  const currentState: DealFormState<T> = useReactiveVar<DealFormState<T>>(dealFormState<T>());

  return { dealForm: currentState, defaultAccountUid };
};
